import { HttpContextToken, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { environment } from '@environments/environment';
import { LoadingStore } from '@app/core/store/loading-store';
import { finalize } from 'rxjs';

export const SKIP_LOADER = new HttpContextToken(() => false);

export const loadingInterceptor: HttpInterceptorFn = (req, next) => {
  const apiUrl = environment.apiUrl.replace(/\/+$/, '');

  if (req.url.startsWith(apiUrl + '/') && !req.context.get(SKIP_LOADER)) {
    const loadingStore = inject(LoadingStore);
    loadingStore.startPageLoading();
    return next(req).pipe(finalize(() => loadingStore.stopPageLoading()));
  }

  return next(req);
};
